import { Navigate } from 'react-router-dom'
import { MdOutlineBarChart } from 'react-icons/md'

import type { IPageConfig } from '@/Core/Contracts/Loaders/IPageConfig'

/**
 * Старий вхід у звіти (`/reports`, збережені посилання): звіти тепер окремими пунктами
 * меню, тож перенаправляємо на перший — «Рейтинг диспетчера».
 */
const IndexPage = () => <Navigate to="/reports/dispatcher-rating" replace />

export default IndexPage

export const pageConfig: IPageConfig = {
    title: 'Звіти',
    route: '/reports',
    icon: <MdOutlineBarChart />,
}
